import LOCALE from '@/common/locale'
import LOCALE_AMENITY from '@/common/locale_amenity'

// return { term: definition, term: definition, ... }
function localeData (lang) {
  let obj = {}
  if (lang) {
    lang = lang.toLowerCase()
    LOCALE[lang].forEach(x => {
      obj[x.term] = x.definition
    })
  }
  return obj
}
function localeAmenityData (lang) {
  let obj = {}
  if (lang) {
    lang = lang.toLowerCase()
    LOCALE_AMENITY[lang].forEach(x => {
      obj[x.term] = x.definition
    })
  }
  return obj
}

export default {
  namespaced: true,
  state: {
    locale: {
      list: Object.keys(LOCALE),
      data: {}
    },
    localeAmenity: {
      list: Object.keys(LOCALE_AMENITY),
      data: {}
    },
    partner: null
  },
  mutations: {
    setLocale (state, ln) {
      const locale = ln ? ln.toLowerCase() : 'en'
      // const defaultLang = state.common.setting ? state.common.setting.lang.info.find(l => l.c === locale) ? ln : state.common.setting.lang.default.toLowerCase() : null
      const lang = state.locale.list.includes(locale)
        ? ln
        : 'en'
      state.locale.data = localeData(lang)
      state.localeAmenity.data = localeAmenityData(lang)
    },
    setPartner (state) {
      const getHost = function (host) {
        if (host.includes('coreguide')) {
        // if (host.includes('8081')) {
          return 'CoreGuide'
        } else {
          return 'iSTAY'
        }
      }
      state.partner = {
        name: getHost(window.location.host),
        url: window.location.origin
      }
    }
  }
}
